module.exports = __webpack_public_path__ + "img/emanuel_wuethrich_tn.46340184.jpg";